export default "https://cdn-static-staging.gokick.com/assets/98f5e78fc13494034d6569c4b787741d65d3002e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";